export default function Pencil({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.2929 6.70711C15.6834 6.31658 16.3166 6.31658 16.7071 6.70711L18.1213 8.12132C18.5118 8.51185 18.5118 9.14501 18.1213 9.53554L16.7071 10.9497L13.8787 8.12132L15.2929 6.70711Z"
        fill="currentColor"
      />
      <path
        d="M13.1716 8.82843L7.51472 14.4853L10.3432 17.3137L16 11.6569L13.1716 8.82843Z"
        fill="currentColor"
      />
      <path
        d="M6.10051 18.7279L9.63604 18.0208L6.80762 15.1924L6.10051 18.7279Z"
        fill="currentColor"
      />
    </svg>
  )
}
